import request from './request';
import notifyError from 'ca-error-handler/notifyError';

// report a request error to bugsnag, optionally with some additional context.
export default function requestErrorHandler(
  xhrOrError: Error | XMLHttpRequest,
  context: Record<string, unknown>,
  requestGroup = 'default'
) {
  const groupingHash = { requestGroup };
  if (xhrOrError instanceof Error) {
    notifyError(xhrOrError, context, groupingHash);
  } else {
    notifyError(new request.RequestError(xhrOrError), context, groupingHash);
  }
}
